import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageEnums } from './Enums/LocalStorageEnums.enum';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from '../services/StorageService.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'arcdox';
  lang!: string;
  dir!: string;
  constructor(
    public translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,private storage: StorageService
  ) {}
 ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const savedLang =this.storage.getLanguage()|| 'ar';

    this.lang = savedLang;
    this.dir = savedLang === 'ar' ? 'rtl' : 'ltr';

    // ngx-translate
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);

    // DOM
    const html = document.documentElement;
    html.setAttribute('lang', savedLang);
    html.setAttribute('dir', this.dir);

    document.body.setAttribute('dir', this.dir);

    // RTL helper class
    if (this.dir === 'rtl') {
        document.body.classList.add('rtl');
    } else {
        document.body.classList.remove('rtl');
    }

    // Force layout recalculation (Bootstrap fix)
    window.dispatchEvent(new Event('resize'));
}
}
